// Персонализация отдельным окном. Содержимое живёт в PersonalizationPanel —
// та же панель встроена в попап пользователя.
import type { ReactElement } from 'react';
import { useT } from '../i18n';
import { Modal } from '../ui/shell/Modal';
import { PersonalizationPanel } from './PersonalizationPanel';

export interface PersonalizationModalProps {
  onClose(): void;
}

export function PersonalizationModal({ onClose }: PersonalizationModalProps): ReactElement {
  const t = useT();
  return (
    <Modal
      title={t('person.title')}
      onClose={onClose}
      footer={
        <button type="button" className="btn btn-primary" onClick={onClose}>
          {t('form.close')}
        </button>
      }
    >
      <PersonalizationPanel />
    </Modal>
  );
}
